module.exports = __webpack_public_path__ + "static/media/left_double_arrow.1e195766.svg";